// material-ui
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';
import { useIntl } from 'react-intl';

// ===========================|| DATA WIDGET - PROJECT TABLE CARD ||=========================== //

const SpectsProduct = ({ product }: { product: any }) => {
    const intl = useIntl();

    return (
        <>
            {product ? (
                <TableContainer sx={{ maxHeight: 850, bgcolor: 'background.paper' }}>
                    <Table>
                        <TableHead>
                            <TableRow sx={{ ml: 3 }}>
                                <TableCell>{intl.formatMessage({ id: 'aspects_to_evaluate' })}</TableCell>
                                <TableCell>{intl.formatMessage({ id: 'complete' })}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{ overflow: 'scroll' }}>
                            <TableRow sx={{ ml: 3 }}>
                                <TableCell>{intl.formatMessage({ id: 'category' })}</TableCell>
                                <TableCell>
                                    {product.categoryScore ? <CheckCircleIcon color="success" /> : <DoNotDisturbOnIcon color="error" />}
                                </TableCell>
                            </TableRow>
                            <TableRow sx={{ ml: 3 }}>
                                <TableCell>EAN</TableCell>
                                <TableCell>
                                    {product.eanUpcScore ? <CheckCircleIcon color="success" /> : <DoNotDisturbOnIcon color="error" />}
                                </TableCell>
                            </TableRow>
                            <TableRow sx={{ ml: 3 }}>
                                <TableCell>{intl.formatMessage({ id: 'title' })}</TableCell>
                                <TableCell>
                                    {product.pageTitleScore ? <CheckCircleIcon color="success" /> : <DoNotDisturbOnIcon color="error" />}
                                </TableCell>
                            </TableRow>
                            <TableRow sx={{ ml: 3 }}>
                                <TableCell>{intl.formatMessage({ id: 'product_reference_code' })}</TableCell>
                                <TableCell>
                                    {product.productReferenceCodeScore ? (
                                        <CheckCircleIcon color="success" />
                                    ) : (
                                        <DoNotDisturbOnIcon color="error" />
                                    )}
                                </TableCell>
                            </TableRow>
                            <TableRow sx={{ ml: 3 }}>
                                <TableCell>{intl.formatMessage({ id: 'sku_reference_code' })}</TableCell>
                                <TableCell>
                                    {product.skuReferenceCodeScore ? (
                                        <CheckCircleIcon color="success" />
                                    ) : (
                                        <DoNotDisturbOnIcon color="error" />
                                    )}
                                </TableCell>
                            </TableRow>
                            <TableRow sx={{ ml: 3 }}>
                                <TableCell>{intl.formatMessage({ id: 'text_link' })}</TableCell>
                                <TableCell>
                                    {product.textLinkScore ? <CheckCircleIcon color="success" /> : <DoNotDisturbOnIcon color="error" />}
                                </TableCell>
                            </TableRow>
                            <TableRow sx={{ ml: 3, background: '#000' }}>
                                <TableCell>{intl.formatMessage({ id: 'dimensions' })}</TableCell>
                                <TableCell />
                            </TableRow>
                            <TableRow>
                                <TableCell>{intl.formatMessage({ id: 'width' })}</TableCell>
                                <TableCell>
                                    {product.dimensionWidthScore ? (
                                        <CheckCircleIcon color="success" />
                                    ) : (
                                        <DoNotDisturbOnIcon color="error" />
                                    )}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>{intl.formatMessage({ id: 'height' })}</TableCell>
                                <TableCell>
                                    {product.dimensionHeightScore ? (
                                        <CheckCircleIcon color="success" />
                                    ) : (
                                        <DoNotDisturbOnIcon color="error" />
                                    )}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>{intl.formatMessage({ id: 'weight' })}</TableCell>
                                <TableCell>
                                    {product.dimensionWeightScore ? (
                                        <CheckCircleIcon color="success" />
                                    ) : (
                                        <DoNotDisturbOnIcon color="error" />
                                    )}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>{intl.formatMessage({ id: 'large' })}</TableCell>
                                <TableCell>
                                    {product.dimensionLargeScore ? (
                                        <CheckCircleIcon color="success" />
                                    ) : (
                                        <DoNotDisturbOnIcon color="error" />
                                    )}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            ) : (
                <p>Cargando ..</p>
            )}
        </>
    );
};

export default SpectsProduct;
